import { createUseMemoStorage } from '@iagent/front-react';

export const { useMemoStorage } = createUseMemoStorage();

